import { useEffect, useState } from "react";
import { BookOpen, Users, UserPlus, BadgeCheck, Wallet, Armchair } from "lucide-react";
import { AdminTitle, Stat, DataTable } from "@/pages/admin/AdminLayout";
import { Badge } from "@/pages/Account";
import { Spinner } from "@/components/site/Bits";
import { useApi, fmtDate, fmtDateTime, fmtPrice } from "@/lib/api";

export default function Dashboard() {
  const api = useApi();
  const [s, setS] = useState(null);
  useEffect(() => {
    api("get", "/admin/stats").then(setS);
  }, [api]);
  if (!s) return <Spinner />;
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle title="الإحصائيات العامة" />
      <div className="grid gap-4 grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
        <Stat label="إجمالي الدورات" value={s.total_courses} Icon={BookOpen} testId="stat-total-courses" />
        <Stat label="إجمالي المتدربين" value={s.total_students} Icon={Users} testId="stat-total-students" />
        <Stat label="تسجيلات جديدة (7 أيام)" value={s.new_registrations} Icon={UserPlus} testId="stat-new-registrations" />
        <Stat label="التسجيلات المؤكدة" value={s.confirmed_registrations} Icon={BadgeCheck} testId="stat-confirmed" />
        <Stat label="إجمالي الإيرادات" value={fmtPrice(s.total_revenue)} Icon={Wallet} testId="stat-revenue" />
        <Stat label="المقاعد المتبقية" value={s.seats_left} Icon={Armchair} testId="stat-seats-left" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-8">
        <div className="min-w-0">
          <h2 className="font-display font-bold text-lg mb-3">الدورات القادمة</h2>
          <DataTable head={["الدورة", "التاريخ", "المقاعد"]} testId="dash-upcoming-table">
            {s.upcoming_courses.map((c) => (
              <tr key={c.id}><td className="max-w-[260px] truncate">{c.title}</td><td className="whitespace-nowrap">{fmtDate(c.date)}</td><td>{c.seats_taken}/{c.seats_total}</td></tr>
            ))}
          </DataTable>
        </div>
        <div className="min-w-0">
          <h2 className="font-display font-bold text-lg mb-3">آخر عمليات الدفع</h2>
          <DataTable head={["المتدرب", "المبلغ", "الحالة", "التاريخ"]} testId="dash-payments-table">
            {s.latest_payments.map((p) => (
              <tr key={p.id}><td>{p.student_name}</td><td className="whitespace-nowrap">{fmtPrice(p.amount)}</td><td><Badge s={p.status} /></td><td className="whitespace-nowrap">{fmtDateTime(p.created_at)}</td></tr>
            ))}
          </DataTable>
        </div>
      </div>
    </div>
  );
}
